import { PARTNER_REFERRAL_SOURCES, ReferralSourceEnum } from '@sondermind/utilities/models-referrals';

import { IReferralSourceMessages } from './referral-source.types';

const PARTNER_KEY: keyof IReferralSourceMessages = 'partnerReferral';

const SOURCE_TO_KEY: Partial<Record<ReferralSourceEnum, keyof IReferralSourceMessages>> = {
  ...Object.fromEntries(PARTNER_REFERRAL_SOURCES.map((s) => [s, PARTNER_KEY])),
  [ReferralSourceEnum.CLIENT_SELF_REFERRAL]: 'selfReferral',
  [ReferralSourceEnum.INTERNAL_REFERRAL]: 'providerReferral',
  [ReferralSourceEnum.PSL_REFERRAL]: 'pslReferral'
};

export function resolveReferralMessageKey(
  source: ReferralSourceEnum | string | null | undefined,
  rematch: boolean
): keyof IReferralSourceMessages {
  // Use referral_source at the source of truth
  const mapped = SOURCE_TO_KEY[source as ReferralSourceEnum];
  if (mapped) return mapped;

  // Fallback to rematch afterwards, not before checking referral_source
  if (rematch) return 'selfReferral';

  return 'default';
}
